import React, { useRef, useState, useEffect } from 'react';
import { Col, Row } from 'react-bootstrap';
import { componentSizeVariantsEnum } from 'src/constants';
import { InputField } from 'src/components/common/formFields';
import { Button, ProfilePicture, Typography, Loader } from 'src/components/common';
import 'bootstrap/dist/css/bootstrap.min.css';
import cx from './cohortRelationship.module.scss';
import { useDispatch, useSelector } from 'react-redux';
import { TMilestone, TTask } from '../../Cohorts/Milestone/milestonetypes';
import { MdAdd } from 'react-icons/md';
import { UploadIcon } from 'src/components/common/common.icons';
import {
  changeSubmittedReportModalState,
  changeTeamSubmittedReportModalState,
  openPopup
} from 'src/store/common/common.slice';
import { TActionButton } from 'src/components/company/programs/viewCohort/viewCohort.types';
import TrackStepper from 'src/components/common/TrackStepper/ActionStepper';
import SubmittedTeamReportSummeryModal from './SubmittedTeamReportSummeryModal';
import GlobalMilestone from 'src/components/company/programs/CohortSidebarComponent/GlobalMilestone/GlobalMilestone';
import { useUrlParamValue, useToggleOpenModal } from 'src/hooks';
import {
  getCohortTeamSuccess,
  removeTeamMember,
  viewcohortTeam,
  getMilestone,
  cohortInvestment,
  viewmycohortTeam,
  createCohortInvestment,
  updateCohortTeam
} from 'src/store/cohort/cohort.slice';
import { httpRequest } from 'src/services/commonApis';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { AppDispatch } from 'src/store/store';
import {
  TExpenses,
  TUpdateInvestmentTracking
} from 'src/components/company/programs/CohortSidebarComponent/InvestmentTracking/updateTracking.types';
import { TInvestemntTracking } from 'src/services/apiEndpoint.types.ts/cohort/Dashboard.types';
import { timeStamp } from 'console';
import { textEllipsis } from 'src/utils';
import TextArea from 'src/components/common/formFields/textArea/TextArea';
import ErrorMessage from 'src/components/common/formFields/errorMessage/ErrorMessage';
import { upArrow } from 'src/assets/images';
import { AiFillCamera } from 'react-icons/ai';
import { RxCross2 } from 'react-icons/rx';
import { APIResponse } from 'src/services/base.api.service';
import { TUploadCompanyProfilePictureResponse } from 'src/services/apiEndpoint.types.ts';
import { CompanyAPIService } from 'src/services/company.service';
import handleExtension from 'src/utils/handleDocumentNameExtension/handleDocumentNameExtension';
import formatINR from 'src/utils/formatINR';
import { Link } from 'react-router-dom';
import Entrepreneur from 'src/assets/images/svg/Entrepreneur.svg';
import MentorBadge from 'src/assets/images/svg/MentorBadge.svg';

interface TOnMilestoneProps {
  handleAction: (screen: string) => void;
}
export default function CohortRelationship({ handleAction: actionHandler }: TOnMilestoneProps) {
  const dispatch = useDispatch<AppDispatch>();
  const isModalOpen: boolean = useAppSelector<boolean>(
    (store: any) => store.common.isTeamSubmittedReportModal
  );
  const { paramValue } = useUrlParamValue();
  const { viewCohortTeam, viewUserCohort, globalLoading }: any = useSelector(
    (state: any) => state?.cohort
  );
  const { profile } = useAppSelector((store) => store.profile);
  // const { loading }: any = useSelector((state: any) => state?.common);
  const teamId: string = paramValue({ paramName: 'teamId' }) as string;
  const cohortId: string = paramValue({ paramName: 'id' }) as string;
  const [updateLoading, setUpdateLoading] = useState<boolean>(false);
  const [error, setError] = useState<string>('')
  const milestoneData = useAppSelector((state: any) => state.cohort.Milestone);
  const [logoLoading, setLogoLoading] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false)
  const [expenseData, setExpenseData] = useState<TExpenses>({
    amount: '',
    userName: profile?.name,
    timestamp: new Date().toString()
  });
  const [about, setAbout] = useState<string>('')

  const steps: { title: string; percentage?: number }[] = milestoneData?.map(
    (milestone: TMilestone) => ({
      title: milestone.cohortMilestoneTitle,
      percentage: milestone.percentage
    })
  );

  const actionButtons: TActionButton[] = [
    { text: 'Milestone', id: 'Milestone', onClick: handleAction },
    { text: 'Resource', id: 'Resource', onClick: handleAction }
    // { text: 'Submit Report', id: 'Submit Report', onClick: handleAction }
  ];
  const isInvestmentTracking = viewUserCohort?.templates?.investmentTracking;

  function handleAction(type: string) {
    if (type === 'Submit Report') {
      dispatch(changeTeamSubmittedReportModalState(true));
    } else {
      actionHandler(type);
    }
  }
  function handleExpense(e: React.ChangeEvent<HTMLInputElement>) {
    setExpenseData({ ...expenseData, amount: +e.target.value });
  }
  const handleSubmit = () => {
    setUpdateLoading(true);
    const data = {
      cohortTeamsId: teamId,
      cohortId,
      fundsAlloted: viewCohortTeam?.investmentTracking?.fundsAlloted || 0,
      expenses: viewCohortTeam?.investmentTracking?.expenses
        ? [
          { ...expenseData, timestamp: new Date().toString() },
          ...viewCohortTeam?.investmentTracking?.expenses
        ]
        : [expenseData],
      additionalsAllotment: viewCohortTeam?.investmentTracking?.additionalsAllotment || []
    };
    dispatch(createCohortInvestment(data)).then((response) => {
      if (response.status) {
        dispatch(cohortInvestment({ cohortId }));
        dispatch(viewmycohortTeam({ teamId }));
        dispatch(
          openPopup({
            popupMessage: response?.message,
            popupType: 'success'
          })
        );
      }
    }).catch((err) => {
      dispatch(
        openPopup({
          popupMessage: err?.message,
          popupType: 'error'
        })
      );
    }).finally(() => {
      setUpdateLoading(false);
    })
  };

  function handleTeam() {
    if (about?.length > 500) {
      setError('maximum word limit reach');
      return
    } else {
      setError('')
    }
    setLoading(true)
    const payload = {
      ...viewCohortTeam,
      teamId: viewCohortTeam?.id,
      about,
      teamMemberIds: viewCohortTeam?.teamMemberMappings?.map((team) => ({ role: team.teamMember?.role, id: team.teamMemberId }))
    }
    dispatch(updateCohortTeam(payload)).then((res) => {
      if (res.status) {
        const payload = { teamId };
        dispatch(viewmycohortTeam(payload));
      }
      setLoading(false)
    }).finally(() => {
      setLoading(false)
    })
  }
  async function handleLogo(
    e: React.ChangeEvent<HTMLInputElement>) {
    if (!e) {
      const payload = {
        ...viewCohortTeam,
        about: viewCohortTeam?.about || '',
        teamId: viewCohortTeam?.id,
        teamMemberIds: viewCohortTeam?.teamMemberMappings?.map((team) => ({ role: team.teamMember?.role, id: team.teamMemberId })),
        profilePic: ''
      }
      dispatch(updateCohortTeam(payload)).then((res) => {
        if (res.status) {
          const payload = { teamId };
          dispatch(viewmycohortTeam(payload));
        }
      })
      return
    }
    if (e.target.files) {
      const files = e.target.files;
      if (files?.length > 0) {
        for (const file of files) {
          const fileName = handleExtension(file?.name?.replaceAll(/\s+/g, ''));
          const reader = new FileReader();
          reader.readAsArrayBuffer(file);
          reader.onload = async () => {
            try {
              setLogoLoading(true);
              const data = reader.result;
              const uploadProfilePicturePayload: any = {
                id: cohortId,
                data,
                showPopup: false
              };
              const response = await httpRequest(
                `cohort/uploads?cohortId=${uploadProfilePicturePayload.id}&resourceName=${fileName}&docCategory=profilePic`,
                'GET',
                null,
                'json',
                'cohort'
              );
              if (response?.data?.signedUrl) {
                const res: APIResponse<TUploadCompanyProfilePictureResponse> | any =
                  await new CompanyAPIService().uploadCompanyProfilePicture({
                    presignedUrl: response?.data?.signedUrl,
                    data,
                    includeAuthorizationHeaders: false
                  });
                if (res.status === 200) {
                  const data = await httpRequest(
                    `cohort/uploads?cohortId=${uploadProfilePicturePayload.id}&resourceName=${fileName}&docCategory=profilePic`,
                    'GET',
                    null,
                    'json',
                    'cohort'
                  );
                  if (response?.data?.signedUrl) {
                    const payload = {
                      ...viewCohortTeam,
                      teamId: viewCohortTeam?.id,
                      about: viewCohortTeam?.about || '',
                      teamMemberIds: viewCohortTeam?.teamMemberMappings?.map((team) => ({ role: team.teamMember?.role, id: team.teamMemberId })),
                      profilePic: data?.data?.key
                    }
                    dispatch(updateCohortTeam(payload)).then((res) => {
                      if (res.status) {
                        const payload = { teamId };
                        dispatch(viewmycohortTeam(payload));
                      }
                    })
                  }
                }
                console.log(res, 'Upload Company Profile Picture Response');
              } else {
                console.error('No signed URL returned in response');
              }
            } catch (error) {
              console.error('Error in file upload process', error);
            } finally {
              setLogoLoading(false);
            }
          };
        }
      }
    }
    setLogoLoading(false);
  }

  useEffect(() => {
    if (teamId && cohortId) {
      const payload = { teamId };
      dispatch(viewmycohortTeam(payload));
    }
    if (teamId && cohortId) {
      const payload = { cohortId, teamId };
      dispatch(getMilestone(payload));
    }
  }, []);
  useEffect(() => {
    if (cohortId) {
      dispatch(cohortInvestment({ cohortId }));
    }
  }, [cohortId]);
  useEffect(() => {
    if (viewCohortTeam?.about) {
      setAbout(viewCohortTeam?.about)
    }
    if (viewCohortTeam?.investmentTracking) {
      setExpenseData({
        ...expenseData,
        amount: viewCohortTeam?.investmentTracking?.expenses?.[0]?.amount || ''
      });
    }
  }, [viewCohortTeam]);

  if (globalLoading === 'team') {
    return <Loader />;
  }
  // const teamInvestment = investmentTrackingData?.find((investement: TInvestemntTracking) => investement.team.id === viewCohortTeam?.id);
  // useEffect(() => {
  //   if (teamInvestment) {
  //     setExpenseTracking(teamInvestment.expenses)
  //   }
  // }, [teamInvestment])
  const initialFund = viewCohortTeam?.investmentTracking?.fundsAlloted || '0'
  const totalAdditionalAllotement =
    viewCohortTeam?.investmentTracking?.additionalsAllotment?.reduce(
      (acc, additionalFund) => acc + additionalFund.amount,
      0
    ) || 0;
  const totalFund = formatINR(+initialFund + +totalAdditionalAllotement)

  return (
    <>
      {isModalOpen && <SubmittedTeamReportSummeryModal />}
      <div className={`${cx.relationship}`}>
        <div className={`${cx.titleHeader}`}>
          <h5 className={`${cx.title}`}>{viewCohortTeam?.cohortTeamsTitle || ''}</h5>
        </div>
        <div className="insideCard">
          <Row>
            <Col md={8} style={{ marginBottom: '8px' }}>
              <div className={cx.details}>
                <h5 className={`${cx.actionHeading}`}>About</h5>
                <TextArea value={about} onChange={(e) => setAbout(e.target.value)} />
                {about?.length > 500 && <ErrorMessage message={"maximum word limit reach"} />}
                {viewCohortTeam && <Button
                  size="small"
                  variant="primary"
                  className={`program-acti,ons__actions__next ${cx.actionBtn}`}
                  type="button"
                  style={{ width: 'auto', marginTop: '8px' }}
                  onClick={handleTeam}
                >
                  <span>{loading ? <Loader /> : 'Update'}</span>
                </Button>}
              </div>
            </Col>
            {viewCohortTeam && <Col md={4} style={{ marginBottom: '8px' }}>
              <div className={cx.details}>
                <h5 className={`${cx.actionHeading}`}>Profile Picture</h5>
                <div className={`${cx.logoBox}`}>
                  <div className={cx.box}>
                    <button
                      className={`${cx.upload_img_remove}`}
                      onClick={() => handleLogo(null)}
                    >
                      {viewCohortTeam?.profilePic ? <RxCross2 /> : ''}
                    </button>
                    {logoLoading ? (
                      <Loader />
                    ) : viewCohortTeam?.profilePic ? (
                      <img
                        style={{
                          height: '130px',
                          width: '138px',
                          borderRadius: '6px',
                          objectFit: 'cover',
                          boxShadow:
                            'rgba(50, 50, 93, 0.25) 0px 2px 4px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px',
                          border: '1px solid gainsboro'
                        }}
                        src={viewCohortTeam?.profilePic || ''}
                        alt="logo"
                      />
                    ) : (
                      <AiFillCamera className={cx.boxImage} />
                    )}

                    {
                      <label className={cx.bottomLogo} htmlFor="team-image-upload">
                        <input
                          type="file"
                          id="team-image-upload"
                          accept="image/*"
                          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                            handleLogo(e)
                          }
                        />
                        <img src={upArrow} alt="logo" style={{ cursor: 'pointer' }} />
                      </label>
                    }
                  </div>
                </div>

              </div>
            </Col>}
          </Row>
        </div>
        <div className="insideCard">
          <Row>
            <Col md={12} style={{ marginBottom: '8px' }}>
              <Row>
                <Col md={12}>
                  <div className={cx.actionButtons}>
                    {actionButtons?.map((button: TActionButton, i: number) => {
                      return (
                        <Button
                          size="small"
                          variant="primary"
                          className={`program-acti,ons__actions__next ${cx.actionBtn}`}
                          type="button"
                          key={button.id}
                          onClick={() => button.onClick(button.text)}
                        >
                          <span className={cx.addIcon}>{i === 2 && <MdAdd />}</span>
                          <span>{button.text} </span>
                        </Button>
                      );
                    })}
                  </div>
                </Col>
                {/* <Col md={3}>
                                <div className={`${cx.percentage}`}>
                                    <span>Percentage completion</span>
                                    <span className={`${cx.highlight}`}>70%</span>
                                </div>
                            </Col> */}
                <Col md={12} className='mt-3 mb-3'>
                  {isInvestmentTracking && (
                    <Row>
                      <Col md={2}></Col>
                      <Col md={2}>
                        <div className={`${cx.fundAction}`}>
                          <InputField
                            label="Total Fund"
                            value={totalFund}
                            disabled
                            readOnly

                            id="expense"
                            variant={componentSizeVariantsEnum.SMALL}
                            placeholder="0"
                            type="text"
                          />
                          {/* <span className={cx.actionValue}>
                            {viewCohortTeam?.investmentTracking?.fundsAlloted || '0'}
                          </span> */}
                        </div>
                      </Col>
                      <Col md={2}>
                        <div className={`${cx.fundAction}`}>
                          <InputField
                            label="Initial Fund"
                            value={formatINR(+initialFund)}
                            disabled
                            readOnly

                            id="expense"
                            variant={componentSizeVariantsEnum.SMALL}
                            placeholder="0"
                            type="text"
                          />
                          {/* <span className={cx.actionValue}>
                            {viewCohortTeam?.investmentTracking?.fundsAlloted || '0'}
                          </span> */}
                        </div>
                      </Col>
                      <Col md={2}>
                        <div className={`${cx.fundAction}`}>
                          <InputField
                            label="Additional Fund"
                            value={formatINR(+totalAdditionalAllotement)}
                            disabled
                            readOnly

                            id="expense"
                            variant={componentSizeVariantsEnum.SMALL}
                            placeholder="0"
                            type="text"
                          />

                        </div>
                      </Col>
                      <Col md={4}>
                        <div className={`${cx.fundAction}`}>
                          <InputField
                            label="Expense"
                            value={expenseData?.amount}
                            onChange={handleExpense}

                            id="expense"
                            variant={componentSizeVariantsEnum.SMALL}
                            placeholder="0"
                            type="number"
                          />
                          <Button
                            size="small"
                            variant="primary"
                            className={`program-acti,ons__actions__next ${cx.actionBtn}`}
                            type="button"
                            style={{ height: '35px', width: '70px', fontSize: '12px', marginTop: '22px' }}
                            onClick={handleSubmit}
                          >
                            {updateLoading ? <Loader /> : <span>Update</span>}
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  )}
                  <Row>
                    <Col md={12} style={{ marginBottom: '10px' }}>
                      <div className={cx.stepper}>
                        <TrackStepper steps={steps} type="cohort" />
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
            <Col md={12}>
              <div className={cx.details}>
                <Row>
                  <Col md={12}>
                    <Row>
                      {/* team list  */}
                      <Col md={6}>
                        <div className="insideCard">
                          <Row>
                            <Col md={12}>
                              <h5 className={`${cx.chatHeading}`}>Teams</h5>
                            </Col>
                            {viewCohortTeam?.teamMemberMappings?.map((team: any) => {
                              const nameWithEllipsis = textEllipsis({
                                charLimit: 70,
                                text: team?.teamMember?.name
                              });
                              return (
                                <Col md={6} key={team.teamMemberId}>
                                  <div className={cx.teamCard}>
                                    <Link to={profile?.id === team?.teamMemberId ? '/my-profile' : `/view-profile?id=${team?.teamMemberId}`}>
                                      <ProfilePicture
                                        url={team?.teamMember?.profilePic}
                                        fallback={team?.teamMember?.name?.[0]?.toLocaleUpperCase()}
                                      />
                                      <div className={cx.profileBox}>
                                        <Typography
                                          as="p"
                                          variant="body-2"
                                          fontWeight="semiBold"
                                          title={team?.teamMember?.name} // Full name on hover
                                        >
                                          <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                            {team?.teamMember?.name.length > 13
                                              ? `${team?.teamMember?.name.slice(0, 13)}...`
                                              : team?.teamMember?.name}
                                            <img
                                              style={{ height: "20px", width: "20px" }}
                                              src={Entrepreneur}
                                              alt="Entrepreneur"
                                            />
                                          </span>
                                        </Typography>
                                      </div>
                                    </Link>
                                  </div>
                                </Col>
                              );
                            })}
                            {viewCohortTeam?.teamMemberMappings?.length === 0 && (
                              <div className="emptyContainerBoxes">
                                <p>No team added yet</p>
                              </div>
                            )}
                          </Row>
                        </div>
                      </Col>
                      {/* mentor list  */}
                      <Col md={6}>
                        <div className="insideCard">
                          <Row>
                            <Col md={12}>
                              <h5 className={`${cx.chatHeading}`}>Mentors</h5>
                            </Col>
                            {viewCohortTeam?.mentorMappings?.map((mentor: any) => {
                              const nameWithEllipsis = textEllipsis({
                                charLimit: 70,
                                text: mentor?.mentor?.name
                              });
                              return (
                                <Col md={6} key={mentor?.mentorId}>
                                  <div className={`${cx.teamCard}`}>
                                    <Link to={profile?.id === mentor?.mentorId ? '/my-profile' : `/view-profile?id=${mentor?.mentorId}`}>
                                      <ProfilePicture
                                        url={mentor?.mentor?.profilePic}
                                        fallback={mentor?.mentor?.name?.[0]?.toLocaleUpperCase()}
                                      />
                                      <div>
                                        <Typography
                                          as="p"
                                          variant="body-2"
                                          fontWeight="semiBold"
                                          title={mentor?.mentor?.name} // Full name on hover
                                        >
                                          <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                            {mentor?.mentor?.name.length > 13
                                              ? `${mentor?.mentor?.name.slice(0, 13)}...`
                                              : mentor?.mentor?.name}
                                            <img
                                              style={{ height: "20px", width: "20px" }}
                                              src={MentorBadge}
                                              alt="Mentor"
                                            />
                                          </span>
                                        </Typography>

                                      </div>
                                    </Link>
                                  </div>
                                </Col>
                              );
                            })}
                            {viewCohortTeam?.mentorMappings?.length === 0 && (
                              <div className="emptyContainerBoxes">
                                <p>No Mentor assign yet</p>
                              </div>
                            )}
                          </Row>
                        </div>
                      </Col>
                    </Row>
                  </Col>

                  <GlobalMilestone type="team" />
                </Row>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
}
